<template>
    <v-layout
        row
        wrap
        class="align-start"
        v-if="Object.keys(languageAttributes).length > 0"
        :class="textColor + '--text'"
        id="productSpecification"
    >
        <v-flex v-for="attributes in attributesByColumns" xs12 :class="'md' + 12 / cols">
            <v-layout row wrap>
                <template v-for="(attribute, indexname, index) in attributes">
                    <v-flex
                        v-if="!hideLabels"
                        xs6
                        class="font-weight-bold py-0"
                        :key="'public-attribute-name-' + index + _uid"
                    >
                        <v-layout row wrap align-center ma-0>
                            <v-flex v-if="anyIconExists" xs2 class="pa-0 d-flex justify-center">
                                <v-img
                                    v-if="getAttributeTypeIcon(indexname)"
                                    :src="getAttributeTypeIcon(indexname)"
                                    contain
                                    width="25"
                                    height="25"
                                />
                            </v-flex>

                            <v-flex xs10 class="pa-0">
                                {{ attribute.name }}
                            </v-flex>
                        </v-layout>
                    </v-flex>

                    <v-flex xs6 :key="index" class="py-0">
                        <div
                            v-for="(valueName, valueKey, index) in getIterableValue(attribute.value)"
                            :key="'public-attribute-value-' + index + _uid"
                        >
                            <template v-if="attribute.linkToSearch">
                                <router-link
                                    :to="
                                $search.buildSearchParams({
                                    attributes: {
                                        [indexname]: attribute.linkValue != undefined ? attribute.linkValue : valueKey,
                                    },
                                })
                            "
                                >
                                    <template v-if="additions && additions[indexname] && additions[indexname].viewType === 'image_select'">
                                        <product-specification-image-type
                                            :imagePath="getAdditionValue(indexname, valueName)"
                                            :name="valueName"
                                        />
                                    </template>

                                    <template v-else>
                                        {{ valueName }}
                                    </template>
                                </router-link>

                                <template v-if="index + 1 != Object.values(getIterableValue(attribute.value)).length">
                                    ,
                                </template>
                            </template>

                            <template v-else>
                                <template v-if="additions && additions[indexname] && additions[indexname].viewType === 'image_select'">
                                    <product-specification-image-type
                                        :imagePath="getAdditionValue(indexname, valueName)"
                                        :name="valueName"
                                    />
                                </template>

                                <template v-else>
                                    <div v-html="valueName" class="text-styles">
                                    </div>
                                </template>


                                <template v-if="index + 1 != Object.values(getIterableValue(attribute.value)).length">
                                    ,
                                </template>
                            </template>
                        </div>
                    </v-flex>
                </template>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
import ProductSpecification from './ProductSpecification';

export default {
    name: 'ProductInfo',
    extends: ProductSpecification,
};
</script>

<style scoped>

</style>